import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './58fa1f07ab76fe84c9e4d2c411cd007cd60b7b4abeea917082422b73d3a79651.cfe-internal.js';
import usePaginationContext from './df75c05401804c6d8142b2bca56715be95f3ec399c9a77fd514147d01733223c.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../icons/index.es.js';
import '../Button/dc121e2f212159f291e6ef8624b9668aa503817b9cff55ab585c7bb9b1925bf2.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import { Button } from '../Button/f53b28c61b990709f9826a4237716d0d9d87dd41248bc45b1ed125999e0b4156.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/d234b5cba8708c34be51c9bf4976cdee0c55fe33ce1598dbff38a5cf644e53a8.cfe-internal.js';
import ChevronRightIcon from '../../icons/components/88a8116bd7f81fb87e1ae07d2c7a465dd4392543779b5970a2459038f6173e7a.cfe-internal.js';

var _excluded = ["data-testid", "disabled", "onClick", "className"];
/**
 * Renders the PaginationNextButton.
 * Either `Pagination` renders this component automatically or the consumer renders this component explicitly.
 */
var PaginationNextButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var dataTestIdFromProps = _ref['data-testid'],
    disabled = _ref.disabled,
    _onClick = _ref.onClick,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var buttonLabel = translate('nextPage');

  // Context for Pagination
  var _usePaginationContext = usePaginationContext(),
    numPages = _usePaginationContext.numPages,
    pageInputValue = _usePaginationContext.pageInputValue,
    dataTestId = _usePaginationContext.dataTestId,
    handlePageChange = _usePaginationContext.handlePageChange,
    setPageInputValue = _usePaginationContext.setPageInputValue;

  /**
   * Increments the `pageInputValue`.
   * Calls `handlePageChange` in order to call the `onPageChange` prop.
   */
  var increment = function increment() {
    var newPage = pageInputValue + 1;
    setPageInputValue === null || setPageInputValue === void 0 || setPageInputValue(newPage);
    handlePageChange === null || handlePageChange === void 0 || handlePageChange(newPage);
  };
  return /*#__PURE__*/React__default.createElement(Button, _extends({}, rest, {
    disabled: disabled !== null && disabled !== void 0 ? disabled : pageInputValue === numPages,
    ref: ref,
    kind: "tertiary",
    onClick: function onClick(e) {
      _onClick === null || _onClick === void 0 || _onClick(e);
      increment();
    },
    className: classNames(className, styles.nextButton),
    "data-testid": dataTestIdFromProps !== null && dataTestIdFromProps !== void 0 ? dataTestIdFromProps : getSubDataTestId(dataTestId, 'NextButton'),
    "aria-label": buttonLabel
  }), /*#__PURE__*/React__default.createElement(ChevronRightIcon, {
    className: styles.btnIcon,
    size: "large",
    "aria-hidden": "true"
  }));
});

export { PaginationNextButton as default };
